import type { TInstrumentName } from '@otter-ai/telemetry';
import { dash } from 'radash';

const INTEGRATIONS_ERROR_BOUNDARY_LOGGER_NAME = 'integrations-error-boundary';
const INTEGRATIONS_ERROR_BOUNDARY_APP_NAME_UNKNOWN = 'unknown';

/**
 * Generate the logger name for an app row based on the app name.
 *
 * Format: `integrations-error-boundary.<app-name>`
 * The app name is converted to kebab-case.
 *
 * @example
 * ```ts
 * createAppRowLoggerName('Google Drive'); // 'integrations-error-boundary.google-drive'
 * createAppRowLoggerName(''); // 'integrations-error-boundary.unknown'
 * ```
 */
export function createAppRowLoggerName(
  name: string,
): TInstrumentName<`${typeof INTEGRATIONS_ERROR_BOUNDARY_LOGGER_NAME}.${string}`> {
  if (!name) {
    return `${INTEGRATIONS_ERROR_BOUNDARY_LOGGER_NAME}.${INTEGRATIONS_ERROR_BOUNDARY_APP_NAME_UNKNOWN}` as TInstrumentName<`${typeof INTEGRATIONS_ERROR_BOUNDARY_LOGGER_NAME}.${string}`>;
  }
  const kebabCaseName = dash(name);
  return `${INTEGRATIONS_ERROR_BOUNDARY_LOGGER_NAME}.${kebabCaseName}` as TInstrumentName<`${typeof INTEGRATIONS_ERROR_BOUNDARY_LOGGER_NAME}.${string}`>;
}
